const YthUsers = (() => {
    let publisherId = $("#hndPublisherId").val();
    $('#users-table').DataTable({
        responsive: true,
        processing: true,
        serverSide: true,

        ajax: {
            url: '/users/listing',
            type: 'POST',
            data: { 'publisher_id': publisherId }
        },
        columns: [
            { data: 'publisher', name: 'publisher_profiles.company' },
            { data: 'name', name: 'name' },
            { data: 'user_type', name: 'user_type' },
            { data: 'email', name: 'email' },
            { data: 'phone', name: 'phone' },
            { data: 'status', name: 'status' },
            {
                data: 'action',
                name: 'action',
                orderable: true,
                searchable: true
            },
        ]
    });

    //delete options
    $(document).on('click', '.delete-users', function (event) {
        const id = $(event.currentTarget).data('id');
        var option_id = $(this).data("id");

        Swal.fire({
            icon: 'error',
            title: 'Do you want to delete?',
            showCancelButton: true,
            confirmButtonText: 'Delete',
            denyButtonText: `Cancel`,
        }).then((result) => {
            if (result.isConfirmed) {
                $.ajax({
                    type: "POST",
                    data: { _method: 'delete' },
                    url: baseUrl + "/users/" + id,
                    success: function (data) {
                        var oTable = $('#users-table').dataTable();
                        oTable.fnDraw(false);
                        Swal.fire(data.message, '', 'success');
                    },
                    error: function (data) {
                        Swal.fire(data.responseJSON.message, '', 'error');
                    }
                });

            } else if (result.isDenied) {
                Swal.fire('Changes are not saved', '', 'info')
            }
        });
    });


    $(document).ready(function () {
        // alert("here");
        // call validation  function etc
    });

    if ($('#smart_sheet_form').length == 0) {
        $(document).on('change', '#email', function (e) {
            let id = $('#userId').val();
            let email = $('#email').val();
            $.ajax({
                url: baseUrl + "/check-users-email/",
                data: { 'id': id, 'email': email },
                success: function (res) {
                    if (res.status == 1) {
                        $('.email-validation').remove();
                        $('#email').addClass('is-invalid');
                        $('<span class="invalid-feedback email-validation" role="alert"><strong>' + res.msg + '</strong></span>').insertAfter('#email');
                    } else {
                        $('.email-validation').remove();
                        $('#email').removeClass('is-invalid');
                    }
                },
            })
        })
    }
});

export default YthUsers;
